import { SERVER_URL } from "../config.js";

export const createMyTasselPlusCheckoutSession = async (authUser) => {
  if (!authUser || authUser.isAnonymous || typeof authUser.getIdToken !== "function") {
    throw new Error("Please sign in before upgrading to MyTassel+.");
  }

  const token = await authUser.getIdToken();
  const response = await fetch(`${SERVER_URL}/mytassel-plus/create-checkout-session`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify({}),
  });

  const payload = await response.json().catch(() => ({}));

  if (!response.ok) {
    throw new Error(payload.message || "Unable to start MyTassel+ checkout.");
  }

  return payload;
};
